module.exports = __webpack_public_path__ + "img/pie_chart.0efffc6b.png";